import { DocumentFile } from "./document-file.model";

export class DocumentVersion {
    IsCurrentVersion: boolean;
    DocumentVersionId: number;
    DocumentVersionStatusId: number;
    DocumentId: number;
    DocumentFileId: number;
    VersionNumber: string;
    Comment: string;
    ValidFrom?: Date;
    ValidTo?: Date;
    InsertBy?: number;
    InsertDate?: Date;
    UpdateBy?: number;
    UpdateByToString: string;
    UpdateDate: Date;
    UpdateDateToString: string;

  DocumentFile: DocumentFile;
  DocumentFiles: DocumentFile[];

  constructor() {
    this.DocumentVersionId = -1;
    this.ValidFrom = new Date();
      this.DocumentFile = new DocumentFile();
      this.DocumentFiles = [];
    }
}
